<h2 mat-dialog-title>Manage Emails</h2>

<mat-dialog-content>
  <ng-container *ngIf="!isLoading; else loadingSpinner">
    <form [formGroup]="emailForm">
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="Enter email">
        <mat-error *ngIf="emailForm.get('email').invalid">Invalid email</mat-error>
      </mat-form-field>
      <button mat-button (click)="addEmail()" [disabled]="emailForm.invalid">Add</button>
    </form>

    <ul>
      <li *ngFor="let email of emails;">
        {{email.email}}
        <button mat-icon-button (click)="removeEmail(email.id)" type="button">
          <mat-icon>remove_circle</mat-icon>
        </button>
      </li>
    </ul>
  </ng-container>

  <ng-template #loadingSpinner>
    <div class="spinner-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="closeDialog()" [disabled]="isLoading">Done</button>
</mat-dialog-actions>
